<template>
  <div class="p-8 bg-white rounded-md shadow-md w-96">
    <div class="flex justify-center p-5">
      <img src="/logo.png" class="w-56" alt="" />
    </div>
    <div class="text-center">
      <h3 class="mb-5 primary--text">{{ $t('login.register_account') }}</h3>
      <!-- <p>เข้าสู่ระบบโดยใช้ ชื่อผู้ใช้งานหรือเบอร์โทรศัพท์</p> -->
    </div>

    <v-form @submit.prevent="login">
      <div class="grid grid-cols-2 gap-1">
        <div>
          <v-text-field
            name="firstName"
            :label="$t('account.first_name')"
            :placeholder="$t('account.first_name')"
            id="firstName"
            background-color="grey lighten-4"
            flat
            solo
            v-model="firstName"
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            name="lastName"
            :label="$t('account.last_name')"
            :placeholder="$t('account.last_name')"
            id="lastName"
            background-color="grey lighten-4"
            flat
            solo
            v-model="lastName"
          ></v-text-field>
        </div>
      </div>
      <v-text-field
        name="signup_email"
        :placeholder="$t('account.email')"
        :label="$t('account.email')"
        background-color="grey lighten-4"
        flat
        id="signup_email"
        solo
        v-model="email"
        autocomplete="on"
      ></v-text-field>
      
      <!-- <v-text-field
        name="signup_tel"
        :label="$t('account.phone_number')"
        :placeholder="$t('account.phone_number')"
        id="signup_tel"
        background-color="grey lighten-4"
        @keypress="NumbersOnly"
        flat
        solo
        v-model="tel"
      ></v-text-field> -->

      <PhoneNumber
        ref="inputPhoneNumber"
        :tel.sync="tel"
        :interTel.sync="interTel"
        flat 
        background-color="grey lighten-4" 
        solo 
        :phoneLabel="$t('account.phone_number')"
        required
        :isLabel="false"
        type="text"
      />

      <v-text-field
        type="password"
        name="signup_password"
        :placeholder="$t('account.password')"
        :label="$t('account.password')"
        background-color="grey lighten-4"
        flat
        id="signup_password"
        solo
        v-model="password"
        :hint="password.length < 8 ? $t('validate.please_input_password_min_character') : ''"
        autocomplete="on"
      ></v-text-field>
      <v-text-field
        type="password"
        name="confirmPassword"
        :placeholder="$t('account.confirm_password')"
        :label="$t('account.confirm_password')"
        background-color="grey lighten-4"
        flat
        id="confirmPassword"
        solo
        v-model="confirmPassword"
        autocomplete="on"
        :hint="
          password == '' || password !== confirmPassword
            ? this.$t('validate.password_not_match')
            : ''
        "
      ></v-text-field>
      <v-btn
        dark
        elevation="0"
        color="primary"
        block
        class="py-3"
        large
        @click="login"
        :disabled="isLoggingIn"
        :loading="isLoggingIn"
        >{{ $t('login.register_title') }}</v-btn
      >
    </v-form>
    <div class="my-3 text-xs text-center">{{ $t('login.already_have_account') }}</div>
    <v-btn
      dark
      elevation="0"
      color="info darken-2"
      outlined
      block
      class="py-3"
      large
      link
      to="login"
      >{{ $t('login.back_to_login') }}</v-btn
    >
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ errMsg }}
    </v-snackbar>
  </div>
</template>

<script>
import PhoneNumber from "@/components/PhoneNumber.vue";
export default {
  name: "Login",
  components: {
    PhoneNumber
  },
  created() {},
  data() {
    return {
      isLoggingIn: false,
      username: "",
      firstName: "",
      lastName: "",
      tel: "",
      interTel: "",
      password: "",
      confirmPassword: "",
      isError: false,
      errMsg: "",
      email: ""
    };
  },
  props: {},
  mounted() {
    localStorage.removeItem("sessionToken");
  },
  methods: {
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async login() {
      try {
        const { firstName, lastName, tel, interTel, password, confirmPassword, email } = this;
        const username = tel;
        if (firstName && lastName && tel && interTel && password && confirmPassword && email) {
          if (password.length >= 8) {
            if (password == "" || password != confirmPassword) {
              this.errMsg = this.$t('account.password_not_match');
              this.isError = true;
            } else {
              this.isLoggingIn = true;
              const signup = await this.$store.dispatch("user/signup", {
                username,
                firstName,
                lastName,
                tel,
                interTel,
                password,
                email
              });
              this.isLoggingIn = false;
              if (signup) {
                this.$router.push("/");
              }
            }
          } else {
            this.errMsg = this.$t('validate.password_min_character');
            this.isError = true;
          }
        } else {
          this.errMsg = this.$t('validate.please_input_all_detail');
          this.isError = true;
        }
      } catch (err) {
        this.errMsg = this.$t('login.register_failed');
        if(err?.response?.data?.error){
          let message = err?.response?.data?.error
          if(message == "Account already exists for this username."){
            this.errMsg = this.$t('validate.phone_number_already_exist');
          }else if(message == "Email address format is invalid."){
            this.errMsg = this.$t('validate.please_input_email_correct');
          }
        }
        this.isLoggingIn = false;
        this.isError = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
